// location (get, set)
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import Geocode from 'react-geocode'
import utils from './utils'

Geocode.setApiKey('AIzaSyAmKx9LiLc2nVaBDMe-O7KeUeRxovHQOz4')

const status = utils.initStatus(['getCached', 'getCoordsFromBrowser', 'getCoordsFromAddress'])

const initialState = {
	// Coords
	coords: {
		lat: 39.89511,
		long: -98.03637,
	},
	// Current Address
	firstLine: '',
	secondLine: '',
	city: '',
	state: '',
	zip: '',
	country: 'United States',

	source: '', //phone
	message: '', //current, address, default,

	markers: [],
	selectedMarker: {
		name: '',
		formatted_address: '',
		formatted_phone_number: '',
	},

	//Location Selector Modal
	isOpen: false,
	status,
}
const parseAddressComponents = (result, thunkAPI) => {
	const addressComponents = result.address_components

	const coords = {
		lat: result.geometry.location.lat,
		long: result.geometry.location.lng,
	}

	let firstLine, city, state, zip, country
	let streetNumber = ''
	let route = ''
	let formatted_address
	if (
		[
			'locality',
			'administrative_area_level_1',
			'postal_code',
			'country',
			'street_number',
		].every(field => addressComponents.some(comp => comp.types.includes(field)))
	) {
		for (const component of addressComponents) {
			if (component.types.includes('locality')) {
				city = component.long_name
			} else if (component.types.includes('administrative_area_level_1')) {
				state = component.short_name
			} else if (component.types.includes('postal_code')) {
				zip = component.long_name
			} else if (component.types.includes('country')) {
				country = component.long_name
			} else if (component.types.includes('street_number')) {
				streetNumber = component.long_name
			} else if (component.types.includes('route')) {
				route = component.long_name
			}
		}
		firstLine = `${streetNumber} ${route}`

		formatted_address = `${firstLine}, ${city}, ${state} ${zip}`

		const data = { coords, firstLine, city, state, zip, country, formatted_address }
		if (thunkAPI) {
			if (result.status != 'OK' /*|| country != 'United States'*/) {
				return thunkAPI.rejectWithValue({ message: 'Location Error' })
			}
		}

		return { data }
	} else {
		const components = result.formatted_address.split(', ')

		const [firstLine, city, state_zip, country] = components
		const [state, zip] = state_zip.split(' ')

		const formatted_address = `${firstLine}, ${city}, ${state} ${zip}`

		const data = { coords, firstLine, city, state, zip, country, formatted_address }
		return { data }
	}
}
export const getCoordsFromBrowser = createAsyncThunk(
	'location/getCoordsFromBrowser',
	async (coords, thunkAPI) => {
		try {
			const res = await Geocode.fromLatLng(Number(coords.lat), Number(coords.long))
			const newLocation = parseAddressComponents(res.results[0])

			return newLocation
		} catch (err) {
			if (err.response) {
				return thunkAPI.rejectWithValue(err.response)
			}
			return thunkAPI.rejectWithValue({ message: 'Location Error' })
		}
	}
)
export const getCoordsFromAddress = createAsyncThunk(
	'location/fromZip',
	async ({ address, doUpdateInfo = true }, thunkAPI) => {
		try {
			const res = await Geocode.fromAddress(address)
			const newLocation = parseAddressComponents(res)

			return newLocation
		} catch (err) {
			return thunkAPI.rejectWithValue(err.response)
		}
	}
)

export const slice = createSlice({
	name: 'location',
	initialState,
	reducers: {
		toggleModal: (state, { payload }) => {
			payload ? (state.isOpen = payload) : (state.isOpen = !state.isOpen)
		},
		updateSource: (state, { payload }) => {
			state.source = payload
		},
		updateCachedPlaces: (state, { payload }) => {
			state.markers = [...state.markers, payload]
		},

		setCurrentMarker: (state, { payload }) => {
			const { formatted_address, firstLine, neighborhood, city } =
				parseAddressComponents(payload)?.data

			state.selectedMarker = {
				...payload,
				formatted_address,
				firstLine,
				neighborhood,
				city,
			}
		},
		clearCurrentMarker: (state, { payload }) => {
			state.selectedMarker = initialState.selectedMarker
		},
	},
	extraReducers: {
		/*
    Get Coords From Browser
    */
		[getCoordsFromBrowser.fulfilled]: (state, { payload }) => {
			const data = payload.data

			utils.handleSuccess(state.status.getCoordsFromBrowser, {
				message: 'Location fetched from coords',
				status: 200,
			})
			state = Object.assign(state, data)

			localStorage.setItem('lat', state.coords.lat)
			localStorage.setItem('long', state.coords.long)
			localStorage.setItem('zip', state.zip)

			// return state
		},
		[getCoordsFromBrowser.rejected]: (state, { payload }) =>
			utils.handleError(state.status.getCoordsFromBrowser, payload?.data),
		[getCoordsFromBrowser.pending]: state =>
			utils.handleLoading(state.status.getCoordsFromBrowser),

		/*
    Get Coords From Address
    */
		[getCoordsFromAddress.fulfilled]: (state, { payload }) => {
			const data = payload.data

			utils.handleSuccess(state.status.getCoordsFromAddress, {
				message: 'Location fetched from address',
				status: 200,
			})
			state = Object.assign(state, data)

			localStorage.setItem('lat', state.coords.lat)
			localStorage.setItem('long', state.coords.long)
			localStorage.setItem('zip', state.zip)

			return state
		},
		[getCoordsFromAddress.rejected]: (state, { payload }) =>
			utils.handleError(state.status.getCoordsFromAddress, payload?.data),
		[getCoordsFromAddress.pending]: state =>
			utils.handleLoading(state.status.getCoordsFromAddress, null),
	},
})

export const {
	toggleModal,
	getCoordsFromStorage,
	updateSource,
	updateCachedPlaces,
	setCurrentMarker,
	clearCurrentMarker,
} = slice.actions

export default slice.reducer
